// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-746984b0] .el-dialog{margin-top:15vh!important;width:500px!important;max-height:30px!important}.download[data-v-746984b0]{color:#1e50ae}.applyOrgBtn[data-v-746984b0]{text-align:right}", ""]);
// Exports
module.exports = exports;
